// Dieses Modul darf nicht global importiert werden, weil es den Rest vom
// importierenden Modul blockiert, falls YooconShop nicht verfügbar ist.
// Stattdessen folgendes verwenden, was nur die aktuelle Funktion blockiert:
//
//      function myfunc() {
//          const {cart} = await import('./yoocon-shop');
//      }

await new Promise(resolve => {
    if(!(window as any).YooconShop) {
        console.error("YooconShop isn't available, some features won't work.");
        return;
    }
    YooconShop.ready(resolve);
});

export const shop = YooconShop.shop;
export const cart = new YooconShop.Cart(shop);
